(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const calendar = document.querySelector(".events-left");
  if (calendar) {
    const rawDate = calendar.dataset.eventDate;
    if (rawDate) {
      const date = new Date(rawDate);
      if (!isNaN(date)) {
        const year = date.getFullYear();
        const monthIndex = date.getMonth();
        const monthName = date.toLocaleString('default', { month: 'long' });
        const day = date.getDate();

        const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

        let gridHTML = "";
        for (let d = 1; d <= daysInMonth; d++) {
          if (d === day) {
            gridHTML += `<div class="highlight">${d}</div>`;
          } else {
            gridHTML += `<div>${d}</div>`;
          }
        }

        calendar.innerHTML = `
          <div class="calendar">
            <div class="header">${monthName} ${year}</div>
            <div class="calendar-grid">${gridHTML}</div>
          </div>
        `;
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
